import { IconCodeTextInputComponent } from './icon-code-text-input.component';

/**
 * アイコンコードテキストインプットManageクラス
 *
 * @export IconCodeTextInputModel
 * @class IconCodeTextInputModel
 */
export class IconCodeTextInputModel {

  public iconList: Array<any> = null;

  /** テキストボックスインスタンス */
  public iconCodeTextInput: IconCodeTextInputComponent = null;
  /** コードリスト取得完了 */
  public completeUpdateIconCodeList: boolean = <boolean>false;

  /**
   * アイコンコードリストアップデート
   *
   * @param {*} serverData serverData:サーバから取得された<Data>タグ
   * @returns
   * @memberof IconCodeTextInputModel
   */
  public updateIconList(serverData: any) {
    if (serverData == null) {
      this.iconList = new Array<any>();
      return;
    }
    this.iconList = serverData;

    this.completeUpdateIconCodeList = true;
    this.iconCodeTextInput.changeIconCodeHandler();
  }

}
